import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { API_URL, authFetch } from "../../services/api";

// Developer landing: non-student configuration only.
// This account cannot access student data; the backend enforces that
// (403 on every non-allowlisted route). This page reads curriculum
// standards (/api/v1/standards), the one read-only surface granted to
// the developer role.
export default function DeveloperHome() {
  const { user } = useAuth();
  const [standards, setStandards] = useState<any>([]);
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authFetch(`${API_URL}/api/v1/standards`);
        if (!res.ok) throw new Error(`Standards request failed (${res.status})`);
        const data = await res.json();
        if (!cancelled) setStandards(Array.isArray(data?.items) ? data.items : []);
      } catch (e: any) {
        if (!cancelled) setError(e.message || "Failed to load standards");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={{ maxWidth: 860, margin: "0 auto", padding: 24 }}>
      <h1>Developer</h1>
      <p>
        Signed in as {user?.email || "developer"} (role: developer).
      </p>
      <div style={{ border: "1px solid #d97706", background: "#fffbeb", borderRadius: 8, padding: 16, marginBottom: 24 }}>
        <strong>This account cannot access student data.</strong>
        <p style={{ margin: "8px 0 0" }}>
          Student records, grades, attendance, rosters, reports, messaging, and
          user management are blocked for this role (HTTP 403). Emergency help
          with live production follows the US-driven screen-share procedure.
        </p>
      </div>

      <h2>Curriculum standards (read-only)</h2>
      {loading && <p>Loading standards…</p>}
      {error && <p role="alert">{error}</p>}
      {!loading && !error && (
        <>
          <p>{standards.length} standards loaded.</p>
          <ul>
            {standards.slice(0, 50).map((s) => (
              <li key={s.standard_id || s.full_code}>
                <strong>{s.full_code}</strong>
                {s.description ? ` — ${s.description}` : ""}
              </li>
            ))}
          </ul>
          {standards.length > 50 && <p>Showing first 50.</p>}
        </>
      )}
    </div>
  );
}
